import { createActionCreator } from "common/ReduxUtils";
import { StorageSelectShippingActionTypes } from "../../../StorageSelectShippingActionTypes";

export const setTotalCargoWeight = createActionCreator<number>(
  StorageSelectShippingActionTypes.STORAGE_SET_TOTAL_CARGO_WEIGHT,
  "totalCargoWeight"
);
